<template>
  <div>
    <ContentWithPaginate
        :page="page"
        :data="allIssues"
        :total-items="pagination.total"
        :items-per-page="pagination.per_page"
        :filter="true"
        :preview="true"
        :loading="loading"
    >
      <template v-slot:filter>
        <ContentHebDateFilter :filters="filter" :filterHandler="filterHandler"></ContentHebDateFilter>
      </template>
    </ContentWithPaginate>
  </div>
</template>
<script lang="ts">
import ContentWithPaginate from '@components/reusable/ContentWithPaginate.vue'
import { useIssuesStore } from '@stores/issues'
import { defineComponent, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ContentHebDateFilter from "@components/reusable/ContentHebDateFilter.vue";
export default defineComponent({
  components: {ContentHebDateFilter, ContentWithPaginate },

  setup() {
    const allIssuesStore = useIssuesStore()
    const route = useRoute()
    const router = useRouter()
    const loading = ref(true)

    const allIssues = ref([])
    const pagination = ref({ current_page: 1, last_page: 1, per_page: 12, total: 0 })
    const filter = ref({years: []})
    const selectedYears = ref<string[]>([])

    const currentPage = () => parseInt(route.query.page as string) || 1

    const loadIssues = async () => {
      loading.value = true
      const params: Record<string, any> = {
        page: currentPage(),
        per_page: 12
      }
      if (selectedYears.value.length) {
        params.years = selectedYears.value
      }
      await allIssuesStore.fetchIssues(params)
      allIssues.value = allIssuesStore.allIssues
      pagination.value = allIssuesStore.pagination
      loading.value = false
    }

    const filterHandler = async (years:any) => {
      selectedYears.value = years ?? []
      if (currentPage() !== 1) {
        // Changing the route resets to page 1 and triggers the watcher below.
        await router.push({ query: { ...route.query, page: undefined } })
        return
      }
      await loadIssues()
    }

    watch(() => route.query.page, async () => {
      await loadIssues()
    })

    onMounted(async () => {
      await loadIssues()
      await allIssuesStore.fetchFilterIssues()
      filter.value = allIssuesStore.filterIssues
    })

    return {
      filterHandler,
      allIssues,
      pagination,
      filter,
      loading
    }
  },

  data() {
    return {
      page: {
        title: 'טעקעס',
        enTitle: 'Issues'
      }
    }
  }
})
</script>
